import axios from "axios";
import { TexProjetoForm } from "features/projetos/pages/ProjetoEditPage/TexDoProjetoPage/TexDoProjetoOffcanvas";

export async function updateTex(data: TexProjetoForm & { textEditId: string | undefined }) {
  return await axios.put(`/Tex/Update`, data);
}